import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { downloadIcon, SVGIcon, trashIcon } from '@progress/kendo-svg-icons';
import { DocumentService } from 'src/app/services/document.service';
import { PdfAndImageService } from 'src/app/services/pdf-image.service';
import { DIALOG_MESSAGES } from '../../constants/notification-messages';
import { StudentDocument } from '../../interfaces/student-document';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    standalone: false
})
export class DocumentsComponent implements OnChanges {
  @Input() documents: StudentDocument[];
  @Input() editMode: boolean;
  @Output() ondeleteDocument: EventEmitter<StudentDocument> =
    new EventEmitter<StudentDocument>();
  @Output() ondownloadDocument: EventEmitter<StudentDocument> =
    new EventEmitter<StudentDocument>();
  @Input() isPhysicalAssessment: boolean = false;
  @Input() hasPermissionDeleteDoc: boolean = true;
  @Input() status: boolean;
  public trashIcon: SVGIcon = trashIcon;
  public downloadIcon: SVGIcon = downloadIcon;

  constructor(
    private documentService: DocumentService,
    private pdfAndImageService: PdfAndImageService,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    library: FaIconLibrary
  ) {
    library.addIcons(faTrash, faDownload);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.documents) {
      this.cdr.detectChanges();
    }
  }

  viewDocument(documentRow: StudentDocument): void {
    if (documentRow.isDoHmhMigrated === true) {
      // Open the document link in a new tab
      window.open(documentRow.docLink, '_blank');
    } else {
      // TODO: Specify `response` with a specific type once the API response is known
      this.documentService
        .getDocument(documentRow.documentRef)
        .subscribe((response) => {
          this.pdfAndImageService.view(response, documentRow.documentFormat);
        });
    }
  }

  confirmDelete(documentRow: StudentDocument): void {
    const dialog: DialogRef = this.dialogService.open({
      title: DIALOG_MESSAGES.confirmTitle,
      content: DIALOG_MESSAGES.deleteDocumentMessage,
      actions: [
        { text: DIALOG_MESSAGES.confirmNo },
        { text: DIALOG_MESSAGES.confirmYes, themeColor: 'primary' },
      ],
      width: 550,
      height: 200,
      minWidth: 350,
    });

    // TODO: Specify `result` with a specific type
    dialog.result.subscribe((result: DialogResult) => {
      if (result instanceof DialogCloseResult) {
        // Dialog was closed without action — no operation needed
      } else {
        if (result.text === DIALOG_MESSAGES.confirmYes) {
          this.deleteDocument(documentRow.documentRef);
        }
      }
    });
  }

  downloadDocument(documentRow: StudentDocument): void {
    if (documentRow.isDoHmhMigrated === true) {
      // Open the document link in a new tab
      window.open(documentRow.docLink, '_blank');
    } else {
      // TODO: Specify the correct type for `response` once the API response structure is known.
      this.documentService
        .getDocument(documentRow.documentRef)
        .subscribe((response) => {
          this.pdfAndImageService.download(
            response,
            documentRow.documentFormat,
            documentRow.documentName
          );
        });
    }
  }

  deleteDocument(entryId: number): void {
    this.documentService.deleteDocument(entryId, 'deleted').subscribe(() => {
      const documentToDelete: StudentDocument = this.documents.find(
        (d: StudentDocument) => d.documentRef === entryId
      );
      if (documentToDelete) {
        this.ondeleteDocument.emit(documentToDelete);
      }
    });
  }
}
